
import { TreeNode } from "@/types/tree";
import { createImageKeywordsBatchRequest } from "./llm";
import { callAIBatch } from "../api/api";
import { jsonParseOrUndefined } from "@/util/json-parse-or-undefined";
import { KeywordsForImageInNodeResponse } from "./types";

export async function getKeywordsForImages(section: TreeNode) {
  const batchRequest = createImageKeywordsBatchRequest(section);

  const responses = await callAIBatch([batchRequest]);
  if (responses.length === 0 || !responses[0].content) {
    throw new Error("No response from AI batch request");
  }
  
  return jsonParseOrUndefined(responses[0].content) as KeywordsForImageInNodeResponse;
}